import React from 'react'
import clsx from 'clsx';

interface ILoader {
    className?: string;
}

const Loader: React.FC<ILoader> = ({ className }) => {
    return (
        <span className='w-full h-full flex items-center justify-center' role='status' aria-label='Loading'>
            <span className={clsx("h-[22px] w-[22px] rounded-full border-[2.5px] border-current border-r-transparent animate-spin", className)} />
        </span>
    )
}

export default Loader
